import { OrderHeaderURLs } from '../../../baseComponents/TwinTable/InputTableLayout/types'

const useQuoteOrderHeaderUrls = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/quote/cost/createQuoteOrderCost',
        updateCost: '/api/app/order/quote/cost/updateQuoteOrderCost',
        deleteCost: '/api/app/order/quote/cost/deleteQuoteOrderCost',
        createFinancialRow: '/api/app/order/quote/financialRow/createQuoteOrderFinancialRow',
        updateFinancialRow: '/api/app/order/quote/financialRow/updateQuoteOrderFinancialRow',
        deleteFinancialRow: '/api/app/order/quote/financialRow/deleteQuoteOrderFinancialRow',
        createAccount: '/api/app/order/quote/orderAccount/createQuoteOrderAccount',
        updateAccount: '/api/app/order/quote/orderAccount/updateQuoteOrderAccount',
        deleteAccount: '/api/app/order/quote/orderAccount/deleteQuoteOrderAccount',
        createShipping: '/api/app/order/quote/shipping/createQuoteShipping', 
        updateShipping: '/api/app/order/quote/shipping/updateQuoteShipping',
        createVariable: '/api/app/order/quote/variable/createQuoteOrderVariable',
        updateVariable: '/api/app/order/quote/variable/updateQuoteOrderVariable',
        deleteVariable: '/api/app/order/quote/variable/deleteQuoteOrderVariable',
        updateWorkingCenter: '',
        createUpdateProductTypes: '/api/app/order/quote/orderProductType/createUpdateQuoteOrderProductTypes',
    }
    return orderHeaderURLs
}

export default useQuoteOrderHeaderUrls